import psychadelicColors from './psychadelicColors.frag.glsl';
import mikuImageUrl from './Hatsune-Miku-vocaloids-30622078-935-1023.jpg';

const canvas = document.getElementById('canvas') as HTMLCanvasElement;
const gl = canvas.getContext('webgl2')!;

// Load Miku texture
const mikuTexture = gl.createTexture();
// Create a single pixel as initial texture to avoid errors before image loads
gl.bindTexture(gl.TEXTURE_2D, mikuTexture);
gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([255, 0, 255, 255]));

const mikuImage = new Image();
mikuImage.src = mikuImageUrl;

mikuImage.onload = () => {
    console.log('Miku image loaded successfully');
    gl.bindTexture(gl.TEXTURE_2D, mikuTexture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mikuImage);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
};

mikuImage.onerror = (err) => {
    console.error('Failed to load Miku image:', err);
};

// Basic vertex shader (just passes coordinates and texture coordinates)
const vertexShaderSource = `#version 300 es
in vec4 a_position;
out vec2 v_texCoord;
void main() {
    gl_Position = a_position;
    // Convert position from clip space (-1 to +1) to texture coordinates (0 to 1)
    v_texCoord = a_position.xy * -0.5 + 0.5;
}`;

// Compile shader
function createShader(type: number, source: string) {
    const shader = gl.createShader(type)!;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error(gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
        throw new Error('Shader compilation failed');
    }
    return shader;
}

// Create shader program
const vertexShader = createShader(gl.VERTEX_SHADER, vertexShaderSource);
const fragmentShader = createShader(gl.FRAGMENT_SHADER, psychadelicColors);
const program = gl.createProgram()!;
gl.attachShader(program, vertexShader);
gl.attachShader(program, fragmentShader);
gl.linkProgram(program);

if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    console.error(gl.getProgramInfoLog(program));
    throw new Error('Program link failed');
}

// Set up a rectangle covering the entire canvas
const positions = new Float32Array([
    -1, -1,  // bottom left
     1, -1,  // bottom right
    -1,  1,  // top left
     1,  1,  // top right
]);
const positionBuffer = gl.createBuffer();
gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);

// Set up vertex attributes
const positionAttributeLocation = gl.getAttribLocation(program, 'a_position');
gl.enableVertexAttribArray(positionAttributeLocation);
gl.vertexAttribPointer(positionAttributeLocation, 2, gl.FLOAT, false, 0, 0);

// Get uniform locations
const timeUniformLocation = gl.getUniformLocation(program, 'u_time');
const canvasWidthLocation = gl.getUniformLocation(program, 'u_canvasWidth');
const canvasHeightLocation = gl.getUniformLocation(program, 'u_canvasHeight');
const mikuTextureLocation = gl.getUniformLocation(program, 'u_mikuTexture');

// Set up resize handler
function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    gl.viewport(0, 0, canvas.width, canvas.height);
}
window.addEventListener('resize', resize);
resize();

// Animation loop
function draw(time: number) {
    gl.useProgram(program);
    gl.uniform1f(timeUniformLocation, time * 0.001); // Convert to seconds
    gl.uniform1f(canvasWidthLocation, canvas.width);
    gl.uniform1f(canvasHeightLocation, canvas.height);

    // Bind Miku texture to texture unit 0
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, mikuTexture);
    gl.uniform1i(mikuTextureLocation, 0);

    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    requestAnimationFrame(draw);
}

draw(0); 
